import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
	faCheckCircle, faChevronRight, faCogs, faCommentSlash,
	faImages,
	faLock,
	faLockOpen,
	faPencil,
	faThumbtack,
	faTrash
} from "@fortawesome/free-solid-svg-icons";
import {MenuItem} from "@szhsin/react-menu";
import React from "react";
import {boardUrl} from "../../../config/config";

const ThreadActionItems = ({thread}) => {
	const actions = [
		{
			title: 'Chỉnh sửa bài viết',
			icon: <FontAwesomeIcon icon={faPencil}/>,
			url: `${thread.view_url}edit`,
			display: thread.can_edit
		},

		{
			title: 'Sửa nội dung bài viết',
			icon: <FontAwesomeIcon icon={faPencil}/>,
			url: `${boardUrl}/index.php?posts/${thread.first_post_id}/edit`,
			display: thread.can_edit
		},

		{
			title: 'Chỉnh sửa ảnh thumbnail',
			icon: <FontAwesomeIcon icon={faImages} />,
			url: `${thread.view_url}edit-thumbnail`,
			display: thread.can_edit_thumbnail
		},

		{
			title: 'Xoá bài viết',
			icon: <FontAwesomeIcon icon={faTrash} />,
			url: `${thread.view_url}delete`,
			display: thread.can_soft_delete && !thread.is_deleted
		},
		{
			title: 'Khôi phục bài viết đã xoá',
			icon: <FontAwesomeIcon icon={faTrash} />,
			url: `${thread.view_url}undelete`,
			display: thread.can_undelete && thread.is_deleted
		},

		{
			title: thread.sticky ? 'Bỏ dán bài viết' : 'Dán bài viết',
			icon: <FontAwesomeIcon icon={faThumbtack} />,
			url: `${thread.view_url}stick-unstick`,
			display: thread.can_stick_unstick
		},

		{
			title: 'Duyệt bài viết',
			icon: <FontAwesomeIcon icon={faCheckCircle} />,
			url: `${thread.view_url}approve`,
			display: thread.can_approve_unapprove && thread.discussion_state === 'moderated'
		},

		{
			title: thread.discussion_open ? 'Khoá bài viết' : 'Mở khoá bài viết',
			icon: <FontAwesomeIcon icon={thread.discussion_open ? faLock : faLockOpen} />,
			url: `${thread.view_url}lock-unlock`,
			display: thread.can_lock_unlock
		},

		{
			title: 'Di chuyển bài viết',
			icon: <FontAwesomeIcon icon={faChevronRight} />,
			url: `${thread.view_url}move`,
			display: thread.can_move
		},

		{
			title: 'Quản lý cấm bình luận',
			icon: <FontAwesomeIcon icon={faCommentSlash} />,
			url: `${thread.view_url}reply-bans`,
			display: thread.can_manage_reply_bans
		},

		{
			title: 'Reset',
			icon: <FontAwesomeIcon icon={faCogs} />,
			url: `${thread.view_url}reset`,
			display: thread.can_reset
		},
	];

	return (
		<>
			{actions.map((item, index) => {
				if (item.display) {
					return (
						<MenuItem key={index} href={item.url}>
							<span className="inline-block mr-2">{item.icon}</span>
							<span>{item.title}</span>
						</MenuItem>
					);
				}
			})}
		</>
	);
}

export default ThreadActionItems;